import axios from '../../../axios';
import ITask from '../types/ITask';
import ITaskSearchParam from '../types/ITaskSearchParam';

const url = '/taskapp/api/task/';

export const taskSearch = (query: ITaskSearchParam) => axios.post(url + 'search', query);

export const createTask = (task: ITask) => axios.post(url, task);

export const updateTask = (task: ITask) => axios.put(url, task);

export const getTaskStatus = (searchType: string) => axios.get(`${url}status-count/${searchType}`);

export const completeTask = (id: string) => axios.post(`${url}complete`, { id });

export const getTaskById = (id: string) => axios.get(`${url}${id}`);
